import React from 'react';
import { Box, Typography, Container, TextField, Button } from '@mui/material';

const ContactPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, md: 8 } }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontSize: { xs: '2rem', md: '2.5rem' } }}>
          Contact
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { xs: '1rem', md: '1.15rem' }, mb: 3 }}>
          Have a question or need support? Fill out the form below and our team will get back to you soon.
        </Typography>
        <Box component="form" sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField label="Name" variant="outlined" fullWidth size="small" />
          <TextField label="Email" variant="outlined" fullWidth size="small" type="email" />
          <TextField label="Message" variant="outlined" fullWidth multiline rows={4} size="small" />
          <Button variant="contained" color="primary" sx={{ mt: 1, py: 1.2, fontSize: { xs: '1rem', md: '1.08rem' } }}>
            Send Message
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ContactPage;
